import { render, staticRenderFns } from "./AgBadge.vue?vue&type=template&id=25b5507a&scoped=true&"
import script from "./AgBadge.vue?vue&type=script&lang=js&"
export * from "./AgBadge.vue?vue&type=script&lang=js&"
import style0 from "./AgBadge.vue?vue&type=style&index=0&id=25b5507a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5507a",
  null
  
)

export default component.exports